// extracted by mini-css-extract-plugin
export var checkoutHoverCard = "_nx-2";
export var interactiveWrapper = "_nx-0";
export var shippingHoverPreview = "_nx-4";
export var summaryBadgeTrigger = "_nx-1";
export var widgetHoverPreviewList = "_nx-3";
export var widgetPreviewScale = "_nx-5";